// extracted by mini-css-extract-plugin
export default {"img":"LogoIcon_img__3KkIU"};